"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageFileSource = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _PropTypes = require("./PropTypes");
var ImageFileSource = exports.ImageFileSource = function ImageFileSource(_ref) {
  var source = _ref.source;
  var url = (0, _typeof2["default"])(source.value) === 'object' ? source.value.url : source.value;
  return _react["default"].createElement("img", {
    src: url,
    alt: source.title
  });
};
ImageFileSource.propTypes = {
  source: _PropTypes.Source
};